import { render, staticRenderFns } from "./PaineisPersonalizadosView.vue?vue&type=template&id=a2b3b282&scoped=true"
import script from "./PaineisPersonalizadosView.vue?vue&type=script&lang=js"
export * from "./PaineisPersonalizadosView.vue?vue&type=script&lang=js"
import style0 from "./PaineisPersonalizadosView.vue?vue&type=style&index=0&id=a2b3b282&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b3b282",
  null
  
)

export default component.exports